import React, { useEffect } from 'react'
import {
  BadgeStatusEntrega,
  Btn,
  CustomCard,
  CustomCheckbox,
  CustomDataTableHeader,
  SectionTitle,
} from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useEtiquetagemVolumes, { ETIQUETAGEM_VOLUMES_ACTIONS } from './EtiquetagemVolumesState'
import { verde } from '../../../../../assets/js/colors'

function EtiquetagemVolumes({ ciclo, dispatch }) {
  const { state, actions, totalVolumesSelecionados } = useEtiquetagemVolumes(ciclo)

  const gerarDesabilitado = totalVolumesSelecionados === 0

  useEffect(() => {
    switch (state.loading) {
      case ETIQUETAGEM_VOLUMES_ACTIONS.LOADING_DELIVERIES:
        dispatch(showLoadingBox('Carregando entregas', 'Aguarde...'))
        break
      default:
        dispatch(hideLoadingBox())
        break
    }
  }, [state.loading])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      actions.resetMessages()
    }
  }, [state.errorMessage])

  const onGerarEtiquetasClick = () => {
    if (gerarDesabilitado) return
    actions.gerarEtiquetas()
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Etiquetagem de Volumes" />
      </div>

      <div className="p-col-4">
        <CustomCard
          title="Total de Entregas"
          subTitle="Quantidade total de entregas"
          valueStyle={{ fontSize: '1.3rem', fontWeight: 600 }}
        >
          {state.totalDeliveries}
        </CustomCard>
      </div>

      <div className="p-col-4">
        <CustomCard
          title="Total de Volumes"
          subTitle="Volumes com código de etiqueta"
          valueStyle={{ fontSize: '1.3rem', fontWeight: 600 }}
        >
          {state.totalVolumes}
        </CustomCard>
      </div>

      <div className="p-col-4">
        <CustomCard
          title="Volumes Selecionados"
          subTitle="Total de etiquetas a imprimir"
          valueStyle={{ color: verde, fontSize: '1.3rem', fontWeight: 600 }}
        >
          {totalVolumesSelecionados}
        </CustomCard>
      </div>

      <div className="p-col-2" style={{ display: 'flex', alignItems: 'center', paddingTop: 52 }}>
        <CustomCheckbox
          checked={state.selecionarTodos}
          onChange={() => actions.onSelecionarTodos()}
        >
          Selecionar Todos
        </CustomCheckbox>
      </div>

      <div className="p-col-10" style={{ paddingTop: 52 }}>
        <Btn onClick={onGerarEtiquetasClick} disabled={gerarDesabilitado}>
          Gerar Etiquetas
        </Btn>
      </div>

      <div className="p-col-12">
        <DataTable
          header={<CustomDataTableHeader onChange={actions.onFilterChange} />}
          value={state.deliveriesFiltered}
          emptyMessage="Não existem entregas associadas a este ciclo"
          rows={10}
          paginator
        >
          <Column
            field="selected"
            header=""
            style={tableCellCentered(50)}
            body={rowData => (
              <CustomCheckbox
                checked={rowData.selected}
                onChange={value => actions.onCheckBoxClicked(rowData, value)}
                disabled={!rowData.qte_volumes}
              />
            )}
          />
          <Column field="identifier" header="Identificador" />
          <Column field="client_fantasia" header="Cliente" />
          <Column field="qte_volumes" header="Qte Volumes" style={tableCellCentered()} />
          <Column field="district" header="Bairro" />
          <Column field="city_name" header="Cidade" />
          <Column
            field="status"
            header="Status"
            body={e => <BadgeStatusEntrega status={e.status} />}
            style={tableCellCentered(170)}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default connect()(EtiquetagemVolumes)
